import moment from 'moment';
import { FETCH_GIVEN_CONSENTS } from '../../actions/carriers';
import { RESET_COMPANY_CONTEXT } from '../../actions';

const givenConsentsInitState = {
  loading: false,
  error: null,
  lastUpdated: moment(),
  data: [],
};

export default function givenConsentsReducer(state = null, { type, payload, meta }) {
  switch (type) {
    case FETCH_GIVEN_CONSENTS.START:
      return {
        ...state,
        loading: true,
        actionId: payload.actionId,
      };
    case FETCH_GIVEN_CONSENTS.SUCCESS:
      if (state.actionId !== meta.previousAction.payload.actionId) {
        return state;
      }

      return {
        ...state,
        data: payload.data.map((entry) => ({
          recipient: entry.recipient,
          consents: (entry.consents || []).map((consent) => ({
            id: consent.id || consent.consentId,
            createdAt: consent.createdAt,
            type: consent.type,
            description: consent.description,
          })),
        })),
        loading: false,
        error: undefined,
        lastUpdated: moment(),
      };
    case FETCH_GIVEN_CONSENTS.FAIL:
      if (state.actionId !== meta.previousAction.payload.actionId) {
        return state;
      }

      return {
        ...state,
        loading: false,
        error: payload,
        data: [],
        lastUpdated: moment(),
      };
    case RESET_COMPANY_CONTEXT:
      return { ...givenConsentsInitState };
    default:
      return state;
  }
}
